import React, { useEffect, useRef } from "react";
import HeaderController from "./HeaderController";
import classes from "./TableArea.module.scss";
import { useState } from "react";
import TableSortLabel from "@mui/material/TableSortLabel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import CustomTablePagination from "../aquaDrafts/atoms/CustomTablePagination";
import { useLocation } from "react-router-dom";
import { InsertDriveFile as InsertDriveFileIcon } from "@mui/icons-material";
import { ApplyFormExisting } from "./modal/ApplyFormFromExisting";
import { IconButton } from "@mui/material";
const TableArea = () => {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const productNoFromQuery = query.get("productNo") ?? "";
  const [productNo, setProductNo] = useState(productNoFromQuery);
  const [kintoneArray, setKintoneArray] = useState([]);
  const [rows, setRows] = useState([]);
  const [targetRow, setTargetRow] = useState(null);
  // ページネーションの状態
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageForTable, setCurrentPageForTable] = useState(0);
  const [countsPerPage, setCountsPerPage] = useState(20);
  const [isShowApplyForm, setIsShowApplyForm] = useState(false);
  //テーブル参照
  const tableRef = useRef(null);

  const columns = [
    createColumn("", "", "left", "30px"),
    createColumn("レコード番号", "id", "left", "100px"),
    createColumn("製番", "製番", "left", "140px"),
    createColumn("ファイル名", "ファイル名", "left", "280px"),
    createColumn("タブ名図面名", "図面名", "left", "120px"),
    createColumn("文書名", "文書名", "left", "100px"),
    createColumn("表示順", "表示順", "left", "100px"),
    createColumn("rev", "rev", "left", "100px"),
    createColumn("最新フラグ", "最新", "left", "120px"),
    createColumn("コメント", "コメント", "left", "120px"),
    // createColumn("URL", "URL", "left"),
    createColumn("備考", "備考", "left", "180px"),
    // createColumn("先行手配", "先行手配", "left", "120px"),
    createColumn("検査", "検査", "left", "100px"),
    createColumn("検査日", "検査日", "left", "100px"),
    createColumn("更新日時", "更新日時", "left", "130px"),
  ];
  const [editIndex, setEditIndex] = useState(0);

  // useEffect(() => {
  //   setRows(kintoneArray);
  //   console.log(kintoneArray);
  // }, [kintoneArray]);

  //表示行設定
  useEffect(() => {
    console.log("currentPage", currentPage);
    // //ページ計算
    // setCurrentPage(1);
    // setCurrentPageForTable(0);
    // const indexOfLastOrder = currentPage * countsPerPage;
    // const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    // setRows(kintoneArray.slice(indexOfFirstOrder, indexOfLastOrder));
    // 配列の長さに基づいて最大ページ数を計算
    const maxPages =
      kintoneArray.length > 0
        ? Math.ceil(kintoneArray.length / countsPerPage)
        : 1;

    // 現在のページが最大ページ数を超えているかどうかをチェック
    let newCurrentPage = currentPage;
    if (currentPage > maxPages) {
      newCurrentPage = maxPages; // 最後のページに設定
    } else if (currentPage < 1) {
      newCurrentPage = 1; // 最初のページに設定（念のため）
    }
    console.log("NewcurrentPage", newCurrentPage);
    // 新しい現在のページを設定
    setCurrentPage(newCurrentPage);

    // テーブル表示用のページ計算（0から始まるインデックスのため、-1をする）
    setCurrentPageForTable(newCurrentPage - 1);

    // 新しいページ範囲に基づいて表示する行を計算
    const indexOfLastOrder = newCurrentPage * countsPerPage;
    const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    setRows(kintoneArray.slice(indexOfFirstOrder, indexOfLastOrder));
  }, [kintoneArray]);
  useEffect(() => {
    console.log("rows:", rows);
  }, [rows]);
  useEffect(() => {
    const indexOfLastOrder = currentPage * countsPerPage;
    const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    setRows(kintoneArray.slice(indexOfFirstOrder, indexOfLastOrder));
  }, [currentPage, currentPageForTable, countsPerPage]);

  // ページ切り替えのハンドラー
  const handleChangePage = (event, newPage, source) => {
    if (tableRef.current) {
      tableRef.current.scrollTo({
        top: 0,
        left: 0,
        //behavior: 'smooth'
      });
    }
    setCurrentPage(newPage + 1);
    setCurrentPageForTable(newPage);
  };
  //表示数切り替えハンドラー
  const handleChangeRowsPerPage = (event) => {
    if (tableRef.current) {
      tableRef.current.scrollTo({
        top: 0,
        left: 0,
        //behavior: 'smooth'
      });
    }
    setCountsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
    setCurrentPageForTable(0);
  };

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("calories");

  function createColumn(id, label, align, width) {
    return { id, label, align, width };
  }

  const handleRequestSort = (event, property) => {
    //以前のコード
    // const isAsc = orderBy === property && order === "asc";
    // setOrder(isAsc ? "desc" : "asc");
    // setOrderBy(property);

    //変更後のコード
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    // setOrder(isAsc ? "asc" : "desc");
    setOrderBy(property);

    // kintoneArrayをソートする
    // const sortedArray = stableSort(
    //   kintoneArray,
    //   getComparator(isAsc ? "asc" : "desc", property)
    // );
    const sortedArray = sortKintoneArray(
      kintoneArray,
      property,
      isAsc ? "desc" : "asc"
    );
    console.log("property", property, "sortedArray", sortedArray);
    setKintoneArray(sortedArray);

    // ソート後にページネーションを適用
    const indexOfLastOrder = currentPage * countsPerPage;
    const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    setRows(sortedArray.slice(indexOfFirstOrder, indexOfLastOrder));
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function sortKintoneArray(arr, propertyName, order = "asc") {
    const arrCopy = [...arr];
    return arrCopy.sort((a, b) => {
      // プロパティが数値か文字列かによって比較方法を変える
      let valA = a[propertyName];
      let valB = b[propertyName];

      // 文字列の場合、大文字小文字を無視するために小文字に変換
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (order === "asc") {
        return valA < valB ? -1 : valA > valB ? 1 : 0;
      } else if (order === "desc") {
        return valA > valB ? -1 : valA < valB ? 1 : 0;
      } else {
        throw new Error('Invalid sort order. Use "asc" or "desc".');
      }
    });
  }

  const StyledTableCell = styled(TableCell)(({ theme, width }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#202226",
      color: "#09A0F2",
      border: 0,
      fontSize: "12px",
      minWidth: width,
      cursor: "pointer",
      "&:hover": {
        color: "#ff0", // ホバー時のフォントカラーを黄色に変更
      },
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "14px",
      border: 0,
      color: "inherit",
      minWidth: width,
      maxWidth: 0, // maxWidthを設定しておくことで、overflowが発生しやすくなる
      whiteSpace: "nowrap", // テキストを折り返さずに一行で表示
      overflow: "hidden", // コンテンツがオーバーフローした場合に非表示にする
      textOverflow: "ellipsis", // オーバーフローしたテキストを省略記号で表示
      // backgroundColor: "#37393F",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#37393F",
      color: "#babcc0",
      border: 0,
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#babcc0",
      border: 0,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  const handleEditIconClick = (row) => {
    setTargetRow(row);
    setIsShowApplyForm(true);
  };
  return (
    <div className={classes.rootContainer}>
      <div className={classes.controller}>
        <HeaderController
          productNo={productNo}
          setProductNo={setProductNo}
          setKintoneArray={setKintoneArray}
        />
        {/* ページネーション */}
        <div className={classes.pagenation}>
          <CustomTablePagination
            component="div"
            count={kintoneArray.length}
            page={currentPageForTable}
            //onPageChange={(event, newPage) => handleChangePage(event, newPage, 'tablepagination')}
            onPageChange={handleChangePage}
            rowsPerPage={countsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[20, 50, 100]}
            // tableRef={tableRef}
          />
        </div>
      </div>
      <div className={classes.table}>
        <StyledTableContainer component={Paper} ref={tableRef}>
          <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <StyledTableCell
                    // sx={{ backgroundColor: "#202226", color: "#09A0F2" }}
                    key={column.id}
                    onClick={createSortHandler(column.id)}
                    align={column.align}
                    width={column.width}
                    // sortDirection={orderBy === column.id ? order : "desc"}
                  >
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      <div>{column.label}</div>
                      <div>
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : "asc"}
                          onClick={createSortHandler(column.id)}
                          sx={{
                            "&:hover": {
                              color: "#ff0", // ホバー時の色
                            },
                            "&.Mui-active": {
                              color: "#09A0F2", // アクティブ時の色
                            },
                            "& .MuiTableSortLabel-icon": {
                              color: "#09A0F2 !important", // アイコンの色
                            },
                          }}
                        ></TableSortLabel>
                      </div>
                    </div>
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy)).map((row) => (
                <StyledTableRow
                  key={row["レコード番号"]}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <StyledTableCell component="th" scope="row">
                    <IconButton
                      aria-label="insertdriveicon"
                      sx={{
                        textAlign: "center",
                        color: "#09A0F2",
                        width: 5,
                        "&:hover": {
                          color: "#ff0", // ホバー時のフォントカラーを黄色に変更
                        },
                      }}
                      onClick={() => handleEditIconClick(row)}
                    >
                      <InsertDriveFileIcon />
                    </IconButton>
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row["レコード番号"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row["URL"] !== null && row["URL"] !== "" ? (
                      <a
                        href={row["URL"]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.linkEffect}
                      >
                        {row["製番"]}
                      </a>
                    ) : (
                      row["製番"]
                    )}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row["ファイル名"]}
                  </StyledTableCell>
                  {/* <StyledTableCell align="left">{row["URL"]}</StyledTableCell> */}
                  <StyledTableCell align="left">
                    {row["タブ名図面名"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row["文書名"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row["表示順"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row["rev"]}</StyledTableCell>
                  <StyledTableCell align="left">
                    {row["最新フラグ"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row["コメント"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row["備考"]}</StyledTableCell>
                  {/* <StyledTableCell align="left">
                    {row["先行手配"]}
                  </StyledTableCell> */}
                  <StyledTableCell align="left">{row["検査"]}</StyledTableCell>
                  <StyledTableCell align="left">
                    {row["検査日"]}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <span style={{ fontSize: "12px" }}>{row["更新日時"]}</span>
                  </StyledTableCell>

                  {/* <TableCell align="right">{row.fat}</TableCell>
                  <TableCell align="right">{row.carbs}</TableCell>
                  <TableCell align="right">{row.protein}</TableCell> */}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </StyledTableContainer>
      </div>
      {isShowApplyForm && (
        <ApplyFormExisting setIsShow={setIsShowApplyForm} data={targetRow} />
      )}
    </div>
  );
};

export default TableArea;
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  margin: "0px 0 0 5px",
  maxHeight: "800px",
  width: "99vw",
  overflowX: "auto",
  // overflowX: "auto", // 横スクロールを有効にする
  // margin: "0 5px",
  // ここからメディアクエリの追加
  [theme.breakpoints.down("md")]: {
    // maxWidth: "660px",
    width: "99vw",
    maxHeight: "none",
    overflowX: "scroll",
  },
  [theme.breakpoints.down("sm")]: {
    // maxWidth: "98%",
    width: "99vw",
    maxHeight: "none",
    overflowX: "scroll",
  },
  // 他に適用したいスタイルがあればここに追加
}));
